export const localHost = (): string =>
  `${window.location.protocol}//${window.location.host}`;
